<template>
  <i v-bind:class="{
      'fa kp-panel-alternative': step.kind === 'multiple-choice',
      'fa kp-panel-yes-no': step.kind === 'yes-no',
      'fa kp-panel-register': step.kind === 'email',
      'fa icon-kp-link': step.kind === 'redirect',
      'fa kp-panel-text': step.kind === 'text'
  }"></i>
</template>

<script>
export default {
  props: [
    'step',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** Icon.vue?99e2b14e
 **/